import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { InstallationDtoResponse, LabourDetailsDtoResponse } from 'app/core/models/labour-details.dto-response';
import { MakeYearModel } from 'app/core/models/make-year-model.model';
import { Observable } from 'rxjs/Observable';
import { Constants, HTTPStatusCode } from '../core/Constants';
import { API_ENDPOINT } from '../core/DI';
import { Helper } from './helper';
import { LeadTimeDtoResponse } from '../core/models/lead-time-dto-response';

@Injectable()
export class SettingService {
  constructor(
    @Inject(API_ENDPOINT) private apiEndpoint: string,
    private http: HttpClient) {
      this.apiEndpoint = apiEndpoint;
    }

  getWheelDrillLeadTime(): Observable<LeadTimeDtoResponse> {
    const api = `${this.apiEndpoint}/settings/wheel/drill/leadtime`;
    return this.http.get<LeadTimeDtoResponse>(api);
  }

  getMountingLeadTime(): Observable<LeadTimeDtoResponse> {
    const api = `${this.apiEndpoint}/settings/mounting/leadtime`;
    return this.http.get<LeadTimeDtoResponse>(api);
  }

  getStuddingLeadTime(): Observable<LeadTimeDtoResponse> {
    const api = `${this.apiEndpoint}/settings/studding/leadtime`;
    return this.http.get<LeadTimeDtoResponse>(api);
  }

  getLeadTime(brand: string, site: string): Observable<LeadTimeDtoResponse> {
    const api = `${this.apiEndpoint}/settings/leadtime?brand=${encodeURIComponent(brand)}&site=${encodeURIComponent(site)}`;
    return this.http.get<LeadTimeDtoResponse>(api);
  }

  postWheelDrillLeadTime(leadTime: string): any {
    const api = `${this.apiEndpoint}/settings/wheel/drill/leadtime`;
    this.http.post(api, { value: leadTime }).toPromise().then(response => {
      return response;
    }).catch((err: any) => {
      return err;
    });
  }

  postMountingLeadTime(leadTime: string): any {
    const api = `${this.apiEndpoint}/settings/mounting/leadtime`;
    this.http.post(api, { value: leadTime }).toPromise().then(response => {
      return response;
    }).catch((err: any) => {
      return err;
    });
  }

  postStuddingLeadTime(leadTime: string): any {
    const api = `${this.apiEndpoint}/settings/studding/leadtime`;
    this.http.post(api, { value: leadTime }).toPromise().then(response => {
      return response;
    }).catch((err: any) => {
      return err;
    });
  }
  getInstallations(mym: MakeYearModel, frontWheelId: string, rearWheelId: string): Observable<InstallationDtoResponse> {
    let api = `${this.apiEndpoint}/settings/installation/` +
      `makes/${Helper.encodeURIComponent2(mym.make)}/` +
      `years/${Helper.encodeURIComponent2(mym.getYearStr)}/` +
      `models/${Helper.encodeURIComponent2(mym.model)}/` +
      `submodels/${Helper.encodeURIComponent2(mym.submodel)}/` +
      `options/${Helper.encodeURIComponent2(mym.option)}/`;
    if (frontWheelId !== '' && rearWheelId !== '') {
      api += `wheels/${frontWheelId}/${rearWheelId}`;
    } else if (frontWheelId !== '') {
      api += `wheels/${frontWheelId}`;
    }
    return this.http.get<InstallationDtoResponse>(api);
  }

  getMTL3PLLeadTime(): Observable<LeadTimeDtoResponse> {
    const api = `${this.apiEndpoint}/settings/3pl/mtl/leadtime`;
    return this.http.get<LeadTimeDtoResponse>(api);
  }
}
